import { Method, AxiosResponse } from "axios"; //https://github.com/axios/axios/blob/master/index.d.ts
import { DeviceType, FixtureTypeEnum } from "./devices";
import { SensorState, SensorType } from "./sensor";
import { CloudRetentionTimeEnum, LicenseTypeEnum } from "./license";

export const axiosMethods: Record<string, Method> = {
  get: "GET",
  post: "POST",
  put: "PUT",
  delete: "DELETE",
  patch: "PATCH",
};
export interface Response extends AxiosResponse {
  data: ResponseAPI;
}
export interface ResponseAPI {
  applicationEvents: ApplicationEvent[];
  payload: any;
  hasErrors: boolean;
  // "ApplicationPagedResponse" only for paged endpoints
  pageNumber?: number;
  pageSize?: number;
  firstPage?: string;
  lastPage?: string;
  totalPages?: number;
  totalRecords?: number;
  nextPage?: string;
  previousPage?: string;
}
export interface ApplicationEvent {
  type: EventTypesConstants;
  code: string;
  message: string;
  parameter: string;
}
export enum EventTypesConstants {
  ErrorEvent = "Error",
  InfoEvent = "Info",
}
export interface QueryFilter {
  pageNumber?: number;
  pageSize?: number;
  from?: string;
  to?: string;
  serialNumber?: string;
  descending?: boolean;
  orderBy?: string;
  emailStartsWith?: string;
  firstNameStartsWith?: string;
  lastNameStartsWith?: string;
  hasPortalAccess?: boolean;
  combinedSearch?: boolean;
  combinedSearchStartsWith?: string;
  deviceType?: DeviceType[] | DeviceType;
  includeSiteInfo?: boolean;
  nameStartsWith?: string;
  includeAvatars?: boolean;
  name?: string;
  like?: string;
  activeOnly?: boolean;
  sensorType?: SensorType;
  sensorState?: SensorState;
  deviceSerialNumber?: string;
  sensorId?: string;
  numberOfLogs?: number;
  date?: string | null;
  includeLicenseInfo?: boolean;
  accountId?: number;
  licenseType?: LicenseTypeEnum;
  cloudRetentionTime?: CloudRetentionTimeEnum;
}

export interface IGetAllDevicesPagedDTO extends IPaginationFilter {
  deviceType?: DeviceType;
  includeSiteInfo?: boolean;
  includeLicenseInfo?: boolean;
  licenseType?: LicenseTypeEnum;
  cloudRetentionTime?: CloudRetentionTimeEnum;
  nameStartsWith?: string;
  deviceSerialNumbers?: string[];
  siteIds?: number[];
  zoneIds?: number[];
  isConnected?: boolean;
  model?: string;
  fixtureType?: FixtureTypeEnum;
}

export interface IPaginationFilter {
  pageNumber?: number;
  pageSize?: number;
  descending?: boolean;
  loadTime?: string;
}
export interface ResponseHookSWR {
  isLoading: boolean;
  isValidating: boolean;
  error: Error;
  data?: ResponseAPI;
  hasErrors: boolean;
}

export const endPoints = {
  securableManagement: "securable-management",
  accountManagement: "account-management",
  deviceManagement: "device-management",
  customerSupportManagement: "customersupport-manager",
  scheduleManagement: "schedule-management",
  siteManagement: "site-management",
  zoneManagement: "zone-management",
  userManagement: "user-management",
  groupManagement: "group-management",
  credentialsManagement: "credentials-management",
  partnerManagement: "partner-management",
  guestManagement: "guest-management",
  guestScheduleManagment: "guest-schedule-management",
  sensorManagement: "sensor-management",
  licenseManagement: "license-management",
};
